import FolderCollection from 'zoomforth_shared_management/legacy_models/folder.collection.js';


var singleton;


const init = function(folderData) {

    singleton = new FolderCollection(folderData);
    return singleton;
  };
const get = function() {
    if (!singleton) {
      throw new Error('Must `init` page-folders app global before you can `get`');
    }
    return singleton;
  }




export { get, init };
export default { get, init };
